import { Directive, Inject, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';

@Directive({
  selector: '[infiniteScroll]'
})
export class InfiniteScrollDirective {

  @Input() set infiniteScrollDisabled(disable: boolean) {
    this._disable = disable;
  }

  @Output() scrolled = new EventEmitter();

  private _disable: boolean;

  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  @HostListener('window:scroll', ['$event'])
    scrolling() {

      let winHeight = window.innerHeight;
      let docHeight = this.document.body.scrollHeight;
      let winScrollTop = window.scrollY;

      //TODO: set infiniteScrollDistance param
      if(docHeight - winHeight - winScrollTop < 100 && !this._disable) {
        this.scrolled.next();
      }

    }

}



// WEBPACK FOOTER //
// ./src/app/directives/infinite.scroll.directive.ts